export class Performance {
  readonly name = `performance`
}

export class Targeting {
  readonly name = `targeting`
}

export class Functional {
  readonly name = `functional`
}

export type ConsentPurpose = Performance | Targeting | Functional

export const performance = new Performance()
export const targeting = new Targeting()
export const functional = new Functional()

interface GrantedPurposes {
  permits: (purpose: ConsentPurpose) => boolean
}

export class Consent {
  private readonly granted: Set<string>

  constructor(purposes: ConsentPurpose[]) {
    this.granted = new Set(purposes.map(purpose => purpose.name))
  }

  permits = (purpose: ConsentPurpose) => this.granted.has(purpose.name)

  withdrawnIn = (next: GrantedPurposes, purpose: ConsentPurpose): boolean =>
    this.permits(purpose) && !next.permits(purpose)
}

export class FullConsent {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  permits = (purpose: ConsentPurpose) => true

  withdrawnIn = (next: GrantedPurposes, purpose: ConsentPurpose): boolean =>
    !next.permits(purpose)
}

export class NoConsent {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  permits = (purpose: ConsentPurpose) => false

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  withdrawnIn = (_next: GrantedPurposes, _purpose: ConsentPurpose): boolean =>
    false
}

export type UserConsent = Consent | FullConsent | NoConsent

export const fullConsent = new FullConsent()
export const noConsent = new NoConsent()
export const consentWithoutTargeting = new Consent([performance, functional])

export class Undecided {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  whenDecided = (activate: (consent: UserConsent) => void): void => {}
}

export class DecidedConsent {
  private readonly consent: UserConsent

  constructor(consent: UserConsent) {
    this.consent = consent
  }

  whenDecided = (activate: (consent: UserConsent) => void): void =>
    activate(this.consent)
}

export type ConsentDecision = Undecided | DecidedConsent

export const undecided = new Undecided()
